<template>
  <div id="user-offline">
    <div class="noti-wrapper">
      <!-- <div class="icon-section">
        <img class="img" :src="`/static/icons/error-icon.svg`" />
      </div> -->
      <div class="content-section">
        <div class="title">
          Internet kapcsolódási problémák
        </div>
        <div class="text">
          Hoppá! Úgy tűnik internet kapcsolódási gondokkal küzdesz!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserOffline"
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#user-offline {
  width: 100vw !important;
  height: 100vh !important;
  position: fixed;
  top: 0;
  z-index: 4;
  backdrop-filter: blur(4px);
  padding-top: 20px;
  .noti-wrapper {
    width: 500px;
    height: 85px;
    max-width: 90vw;
    background-color: white;
    border-radius: 20px;
    border-radius: 8px;
    box-shadow: 0px 5px 10px 4px #00000029;
    margin: auto;
    z-index: $Z-dropdown-noti;
    display: flex;

    .icon-section {
      height: 100%;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 15px;
      .img {
        width: 50px;
        height: 50px;
      }
    }
    .content-section {
      display: flex;
      flex-grow: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      .title {
        height: 35px;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-weight: bold;
        padding-left: 10px;
        padding-right: 10px;
      }
      .text {
        font-size: 15px;
        text-align: center;
        padding: 2px 10px 0 10px;
        margin: auto;
        padding-bottom: 10px;
      }
    }
  }
}
</style>
